export function sortSeries(rows = [], sortKey = "growth") {
  const key = sortKey === "spend" ? "projected_spend" : "growth_eur";
  return [...(rows || [])].sort((a, b) => (b[key] || 0) - (a[key] || 0));
}

// hasNoData flags a series the model produced nothing meaningful for: no
// projected spend, no growth, and never rated. These add noise to the ranking
// without telling the user anything, so the Explorer hides them.
export function hasNoData(row = {}) {
  const noSpend = row.projected_spend == null || row.projected_spend === 0;
  const noGrowth = row.growth_eur == null || row.growth_eur === 0;
  const unrated = row.algorithm == null || row.algorithm === "";
  return noSpend && noGrowth && unrated;
}

// filterSeries drops the empty/unrated series flagged by hasNoData.
export function filterSeries(rows = []) {
  return (rows || []).filter((r) => !hasNoData(r));
}
